export default "__VITE_ASSET__MDydoElL__"